import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "aw-hubspot-form",
  ref: "root"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScriptComponent = _resolveComponent("ScriptComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ScriptComponent, {
      value: _ctx.formScript,
      onOnscriptloaded: _ctx.scriptLoaded
    }, null, 8, ["value", "onOnscriptloaded"]),
    _createVNode("div", {
      id: "hsform_container",
      style: _ctx.hsFormVars
    }, null, 4)
  ], 512))
}